module.exports = {"370523001":"广饶街道","370523002":"乐安街道","370523003":"丁庄街道","370523101":"大王镇","370523102":"稻庄镇","370523106":"李鹊镇","370523107":"大码头镇","370523108":"花官镇","370523109":"陈官镇","370523400":"东营农业高新技术产业示范区","370523401":"滨海新动能产业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370523.json
// module id = 1512
// module chunks = 0